// Rules for the appointment checkout (/c/checkout?app=true), senior or not.
//
// Kept pure (no React) so they are unit-tested. The elementary booking flow has
// gone straight from the time picker to this page since 5/2024, skipping the
// appointment-review step that held the only coupon box, so a retake parent had
// nowhere to enter a code. Seniors got a box here in 6/2026; elementary now does
// too.

// A coupon box on every appointment checkout, once the cart has loaded.
export const showsAppointmentCoupon = ({ app, cart }) => !!app && !!cart;

const isAppointmentOnly = (cart) => {
  const orderPackages = cart.orderPackages || [];
  return orderPackages.length > 0 && orderPackages.every((op) => !!op.appointmentTime);
};

// A sitting that costs nothing books directly: no billing, no shipping. This is
// the client half of Order#appointment_only_and_free?, which lets the server
// accept it without a shipping address. For an elementary booking it asks the
// same thing the server does -- every line is a sitting -- so a free cart that
// also holds goods keeps its shipping step. The senior rule is as it was.
export const isFreeSitting = ({ app, senior, cart }) => {
  if (!app || !cart || cart.apiTotal !== 0) return false;
  if (senior) return true;

  return isAppointmentOnly(cart);
};
